import { setByPath } from "../../../../dot-notation/index.js";
import { produce } from "../../../../immer/index.js";
import { createProperty } from "../../utils/createProperty.js";
function updateFieldsAndValues(store, changedValues, privateFieldApi) {
  const { tryToCreateField } = privateFieldApi;
  store.values = produce(store.values, (draft) => {
    for (const [targetFieldPath, fieldValue] of Object.entries(changedValues)) {
      const fieldPath = targetFieldPath;
      try {
        setByPath(draft, fieldPath, fieldValue);
      } catch (e) {
        createProperty(draft, fieldPath, fieldValue);
      }
    }
  });
  for (const [key, fieldValue] of Object.entries(changedValues)) {
    const targetFieldName = key;
    const target = store.fields[targetFieldName];
    if (!target) {
      tryToCreateField(targetFieldName, fieldValue);
    }
  }
  store.fields = produce(store.fields, (draft) => {
    for (const [key, fieldValue] of Object.entries(changedValues)) {
      const targetFieldName = key;
      const target = draft[targetFieldName];
      target.value = fieldValue;
      target.status = "indeterminate";
    }
  });
}
export {
  updateFieldsAndValues
};
//# sourceMappingURL=createCoreApi.updateFieldsAndValues.js.map
